import React from 'react'
import Footer from 'components/Footer/Footer.js'
import harmony from '../../images/harmony.jpg'
import { isDesktop, isMobile } from 'react-device-detect'
import AnnoyingConsent from 'components/Header/AnnoyingConsent'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import ErrorLine from 'components/ErrorLine'
import { displayError } from 'util/screenUtils'
import harmonySmall from 'images/harmony-small.jpg'
import { isGooglebot } from 'util/screenUtils'
import { setShowWelcome } from 'redux/actions/helpActions'
import { isVeryNarrow } from 'util/screenUtils'
import { useMediaQuery } from '@material-ui/core'
import BlurDialog from 'components/utility/BlurDialog'
import { setShowAnnoyingConsent } from 'redux/actions/helpActions'
import { setContinuousPlay } from 'redux/actions/displayActions'
import SwipeCard from 'components/harmonize/SwipeCard'
import { fetchSongsAndVideo } from 'util/fetchUtils'
import { setFetchInProgress, setQuery } from 'redux/actions/fetchActions'
import { setPlayListIndex } from 'redux/actions/harmonizeActions'
import { track } from 'util/analyticsUtil'
import { ANALYTICS_EVENTS } from 'util/analyticsUtil'
import { useHistory } from 'react-router-dom'
import { HelpOutline } from '@material-ui/icons'

export default function HarmonizeHome() {
  const backgroundStyles = {
    normal: {
      backgroundSize: 'contain'
    }
  }
  const veryNarrow = isVeryNarrow(useMediaQuery)
  const { fetchInProgress, fetchStart, query } = useSelector(state => state.fetch)
  const { showAnnoyingConsent, showWelcome } = useSelector(state => state.help)
  const [showSignIn, setShowSignIn] = useState(false)
  const [error, setError] = useState('')
  const history = useHistory()
  const dispatch = useDispatch()

  const welcomeContent = () => {
    return (<div>
      <h5 style={{ display: 'flex', justifyContent: 'center' }}>Streaming music and video all in one place</h5>
      <ul>
        <li><a href='/About' target='_blank'>Creators are paid</a> for every 10 seconds of streaming</li>
        <li>Listeners pay <a href='/Pricing' target='_blank'>as little as $1</a> with no monthly fees and no ads</li>
        {isMobile ? <li>Swipe up or down for songs and video. Swipe right to like</li> : null}
        {isDesktop ? <li>Click forward and back in the player controls for new content</li> : null}
        <li>Click this <HelpOutline style={{ fontSize: '1.5em', verticalAlign: 'bottom' }} /> in the left panel for more help</li>
      </ul>
      <h5 style={{ display: 'flex', textAlign: 'center', color: 'blue', cursor: 'pointer' }}>
        For a limited time new accounts get 100 free streaming minutes!</h5>
    </div >)
  }
  const displaySignIn = () => {
    if (showSignIn && !isGooglebot(window.navigator.userAgent)) {
      history.push('/SignIn')
      dispatch(setShowAnnoyingConsent(true))
    }
  }
  const displayWelcome = () => {
    if (showWelcome && !isGooglebot(window.navigator.userAgent)) {
      return (<div onClick={() => {
        dispatch(setShowWelcome(false))
        track(ANALYTICS_EVENTS.HIDE_WELCOME)
      }
      }>
        <BlurDialog content={welcomeContent}
          image={harmonySmall}
          blurStyle={{ borderRadius: '2em', padding: '1em', zIndex: 10000 }}
          imageStyle={{ display: 'flex', width: '40vw', marginLeft: 'auto', marginRight: 'auto' }}
          hideHelp closeIcon close={() => {
            dispatch(setShowWelcome(false))
            dispatch(setShowAnnoyingConsent(true))
            track(ANALYTICS_EVENTS.CLOSE_WELCOME)
          }
          } top={veryNarrow ? '5vh' : '10vh'} />
      </div >)
    }
  }
  const displayLoading = () => {
    console.log(`HarmonizeHome displayLoading `)
    return (
      <div>
        <div style={{
          ...backgroundStyles.normal, ...{
            backgroundImage: `url(${harmony})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            height: '100vh',
            opacity: 1
          }
        }} />

        <Footer />
      </div>
    )
  }

  const displayConsent = () => {
    if (showAnnoyingConsent) {
      return <AnnoyingConsent onAccept={() => {
        dispatch(setShowAnnoyingConsent(false))
        dispatch(setContinuousPlay(true))
      }} />
    }
  }
  const displayMain = () => {
    console.log(`HarmonizeHome displayMain 
    fetchStart ${fetchStart}, 
    query ${query}`)
    return (
      <div>
        <SwipeCard />
        {displayWelcome()}
        {displayConsent()}
        {displaySignIn()}

      </div>
    )

  }


  useEffect(() => {
    console.log(`(*) HarmonizeHome useEffect start`)
    setError()
    dispatch(setFetchInProgress(false))
    dispatch(setQuery(null))
    dispatch(setPlayListIndex(0))
    return () => {
      dispatch(setFetchInProgress(false))
      console.log(`(*) HarmonizeHome UNMOUNTED`)
    }
  }, [])
  useEffect(() => {
    console.log(`(*) HarmonizeHome useEffect 
     fetchStart ${fetchStart} query ${query}`)
    document.title = process.env.REACT_APP_NAME
    fetchSongsAndVideo(dispatch).catch(error => {
      dispatch(setFetchInProgress(false))
      displayError(error, setError)
    })
  }, [fetchStart])
  return (

    <div>
      <ErrorLine error={error} />
      {fetchStart < 1 && fetchInProgress ? displayLoading() : displayMain()}
    </div>

  )
}
